import { LayoutActionTypes } from './types';

export const setCollapsibleNavbar = () => ({
  type: LayoutActionTypes.SET_COLLAPSED_NAVBAR,
});
